if (!customElements.get('oct-collection-grid')) {
  customElements.define('oct-collection-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const one = s => this.querySelector(s);
      const all = s => [...this.querySelectorAll(s)];
      const grid = one('.oc2-grid');
      let cards = [];
      const edit = Boolean(this.dataset.edit);
      const pinned = (this.dataset.pins || '').split(',').filter(Boolean);
      const featuredOrder = card => card.order;
      const preset = edit ? null : this.dataset.preset || new URLSearchParams(location.search).get('selection');
      let activeCategory = ['singlets', 'crops', 'bottoms', 'accessories', 'men', 'women'].includes(preset) ? preset : 'all';
      const categoriesFor = category => category === 'all' ? [] : category === 'men' ? ['singlets','bottoms','accessories'] : category === 'women' ? ['crops','bottoms','accessories'] : [category];
      let categories = categoriesFor(activeCategory);
      let visible = Infinity, sizes = [], maxPrice = Infinity, inStock = false;
      const ingest = elements => elements.forEach(element => {
        if (cards.some(c => c.element.dataset.id === element.dataset.id)) return;
        const product = JSON.parse(element.querySelector('[data-product]').textContent);
        cards.push({ element, product, order: cards.length });
      });
      ingest(all('[data-card]'));
      const buildSizes = () => {
        const values = [...new Set(cards.flatMap(c => c.product.variants.flatMap(v => v.options)))].filter(s => s !== 'Default Title');
        const preferred = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', 'One Size'];
        values.sort((a,b) => (preferred.indexOf(a) < 0 ? 100 : preferred.indexOf(a)) - (preferred.indexOf(b) < 0 ? 100 : preferred.indexOf(b)) || a.localeCompare(b));
        one('[data-filter-sizes]').replaceChildren(...values.map(value => {
          const label = document.createElement('label'), input = document.createElement('input');
          input.type = 'checkbox'; input.name = 'size'; input.value = value; input.checked = sizes.includes(value);
          label.append(input, document.createTextNode(value)); return label;
        }));
      };
      const rotationHeading = one('.oc2-rotation-heading') || document.createElement('h2');
      rotationHeading.className = 'oc2-rotation-heading';
      rotationHeading.textContent = 'Shop other designs';
      const render = () => {
        rotationHeading.remove();
        const filtered = cards.filter(({element,product:p}) => (!categories.length || categories.includes(element.dataset.category)) && p.variants.some(v => (!sizes.length || sizes.some(s => v.options.includes(s))) && v.price <= maxPrice && (!inStock || v.available)));
        const sort = one('[data-sort]').value;
        filtered.sort((a,b) => sort === 'price-low' ? a.product.price-b.product.price : sort === 'price-high' ? b.product.price-a.product.price : sort === 'newest' ? Number(b.product.created)-Number(a.product.created) : sort === 'name' ? a.product.title.localeCompare(b.product.title) : featuredOrder(a)-featuredOrder(b));
        cards.forEach(c => { c.element.hidden = true; });
        filtered.forEach((c,i) => { c.element.hidden = i >= visible; grid.append(c.element); });
        if (edit && sort === 'featured' && !categories.length && !sizes.length && maxPrice === Infinity && !inStock) {
          const firstRest = filtered[pinned.length];
          if (firstRest) grid.insertBefore(rotationHeading, firstRest.element);
        }
        one('[data-count]').textContent = `${filtered.length} products`;
        one('[data-empty]').hidden = !!filtered.length;
        const active = sizes.length + (maxPrice < Infinity ? 1 : 0) + (inStock ? 1 : 0);
        one('[data-filter-open]').textContent = active ? `Filter (${active}) +` : 'Filter +';
      };
      const categoryTitles = {all: 'Shop all', singlets: 'Shop singlets', crops: 'Shop crop singlets', bottoms: 'Shop shorts & tights', accessories: 'Shop accessories', men: 'Shop men', women: 'Shop women'};
      const updateTabs = () => {
        all('.oc2-tabs a').forEach(b => b.setAttribute('aria-current', b.dataset.category === activeCategory ? 'page' : 'false'));
      };
      buildSizes(); updateTabs();
      one('[data-sort]').addEventListener('change', () => { visible = Infinity; render(); });
      const filter = one('[data-filter]');
      all('dialog').forEach(dialog => {
        dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          const r = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
        });
      });
      one('[data-filter-open]').addEventListener('click', () => filter.showModal());
      one('[data-filter-form]').addEventListener('submit', event => {
        event.preventDefault();
        sizes = all('[data-filter-sizes] input:checked').map(e => e.value);
        const value = one('[name="max_price"]').value;
        maxPrice = value === '' ? Infinity : Math.round(Number(value)*100);
        inStock = one('[name="in_stock"]').checked; visible = Infinity;
        filter.close(); render();
      });
      all('[data-reset]').forEach(button => button.addEventListener('click', () => {
        sizes = []; maxPrice = Infinity; inStock = false; visible = Infinity;
        one('[data-filter-form]').reset(); render();
      }));
      const loadRemaining = async () => {
        let next = this.dataset.next;
        try {
          while (next && this.isConnected) {
            const url = new URL(next, location.origin); url.searchParams.set('view','style-2'); url.searchParams.set('section_id',this.dataset.section);
            const response = await fetch(url);
            if (!response.ok) throw new Error('load');
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            const root = doc.querySelector('oct-collection-grid');
            if (!root) throw new Error('load');
            ingest([...root.querySelectorAll('[data-card]')]);
            next = root.dataset.next; buildSizes(); render();
          }
        } catch (_) { one('[data-load-error]').textContent = 'Some products could not load. Refresh to try again.'; }
      };
      loadRemaining();
    }
  });
}
